<template>
    <div class="searchContent">
        <a-affix>
            <a-card :title="this.$slots.default">
                <a-form layout="inline" @submit="handleSubmit" :form="form">
                    <a-form-item label="关键字">
                        <a-input
                            v-decorator="[
                                'keyword',
                                {
                                    initialValue: record.keyword || '',
                                }
                            ]"
                            placeholder="请输入关键字"
                        ></a-input>
                    </a-form-item>

                    <a-form-item label="名单类型">
                        <a-select
                            style="width:160px"
                            v-decorator="[
                                'nltype',
                                {
                                    initialValue: record.nltype || [],
                                }
                            ]"
                            placeholder="选择名单类型"
                        >
                            <a-select-option key="0">黑名单</a-select-option>
                            <a-select-option key="1">白名单</a-select-option>
                            <a-select-option key="2">接口黑名单</a-select-option>
                            <a-select-option key="3">接口白名单</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-button
                            type="primary"
                            htmlType="submit"
                            :key="this.loading.key"
                            :loading="this.loading.effects[selectType]"
                        >查询</a-button>
                        <v-resetbutton
                            :key="Math.random()"
                            :loading="this.loading.effects[selectType]"
                            :redirect="{path:`/${storeNamespace}/list`}"
                            class="ml15"
                        >重置</v-resetbutton>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-affix>
    </div>
</template>

<script>
// import { mapState } from "vuex";

const storeNamespace = "rc/rule";

export default {
    data() {
        return {
            storeNamespace,
            selectType: `${storeNamespace}/select`,
            deleteType: `${storeNamespace}/delete`,
            form: this.$form.createForm(this),
            record: this.$route.query || {}
        };
    },
    computed: {},
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;

                /**
                 * 是的你没看错，这边触发重新去查询数据，只要让路由改变query的参数值即可，无需this.$store.dispatch({})去调用actions里面的方法，
                 * dispatch由同辈级(兄弟组件)  tablelist.vue 中去处理。
                 */
                this.$router.push({
                    path: "list",
                    query: values
                });
            });
        }
    },
    mounted() {
        //获取部门信息下拉框数据
        /* this.$store.dispatch({
            type: "department/getDepartmentSelectOptions"
        }); */
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-bottom: 20px;
}
</style>